// extracted by mini-css-extract-plugin
export var lg = "_eh-7";
export var md = "_eh-6";
export var placeholderContainer = "_eh-1";
export var placeholderIcon = "_eh-2";
export var productImage = "_eh-0";
export var sm = "_eh-5";
export var xl = "_eh-8";
export var xs = "_eh-4";
export var xxs = "_eh-3";